/**
 * @generated SignedSource<<b06999a629ad2881587d6112bfc52f9b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type NoteTemplateSubmissionStatus = "ACCEPTED" | "CHANGES_REQUIRED" | "CONDITIONALLY_ACCEPTED" | "OPEN" | "REJECTED" | "UNDER_REVIEW";
export type noteTemplateGqlSubmitTemplateMutation$variables = {
  authorInfo: any;
  templateId: string;
  termsAccepted: boolean;
};
export type noteTemplateGqlSubmitTemplateMutation$data = {
  readonly submitNoteTemplate: {
    readonly submission: {
      readonly id: string;
      readonly status: NoteTemplateSubmissionStatus;
    } | null;
    readonly template: {
      readonly id: string;
      readonly submission: {
        readonly id: string;
        readonly status: NoteTemplateSubmissionStatus;
      } | null;
    } | null;
  } | null;
};
export type noteTemplateGqlSubmitTemplateMutation = {
  response: noteTemplateGqlSubmitTemplateMutation$data;
  variables: noteTemplateGqlSubmitTemplateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "authorInfo"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "templateId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "termsAccepted"
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "NoteTemplateSubmissionNode",
  "kind": "LinkedField",
  "name": "submission",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "authorInfo",
        "variableName": "authorInfo"
      },
      {
        "kind": "Variable",
        "name": "templateId",
        "variableName": "templateId"
      },
      {
        "kind": "Variable",
        "name": "termsAccepted",
        "variableName": "termsAccepted"
      }
    ],
    "concreteType": "SubmitNoteTemplate",
    "kind": "LinkedField",
    "name": "submitNoteTemplate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NoteTemplateNode",
        "kind": "LinkedField",
        "name": "template",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      },
      (v4/*: any*/)
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "noteTemplateGqlSubmitTemplateMutation",
    "selections": (v5/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "noteTemplateGqlSubmitTemplateMutation",
    "selections": (v5/*: any*/)
  },
  "params": {
    "cacheID": "964310766ef9a92f79f6c04b67170e9d",
    "id": null,
    "metadata": {},
    "name": "noteTemplateGqlSubmitTemplateMutation",
    "operationKind": "mutation",
    "text": "mutation noteTemplateGqlSubmitTemplateMutation(\n  $templateId: ID!\n  $authorInfo: JSON!\n  $termsAccepted: Boolean!\n) {\n  submitNoteTemplate(templateId: $templateId, authorInfo: $authorInfo, termsAccepted: $termsAccepted) {\n    template {\n      id\n      submission {\n        id\n        status\n      }\n    }\n    submission {\n      id\n      status\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "013f25e52b94817a39f46cccc1aae8ab";

export default node;
